import React from 'react';
import * as Styled from 'components/PageWrappers/AdDetails/components/VehicleFeatures/VehicleFeatures.styled';
import { InfoTitle } from 'components/Toolkit/InfoTitle/InfoTitle';
import { SeeMoreFade } from 'components/Toolkit/SeeMoreFade/SeeMoreFade';

import type {
  VehicleFeaturesShowMoreProps,
  MappedVehicleFeatures,
} from 'components/PageWrappers/AdDetails/components/VehicleFeatures/VehicleFeatures.typed';

const VehicleFeaturesShowMore = React.forwardRef<
  HTMLDivElement,
  VehicleFeaturesShowMoreProps
>((props: VehicleFeaturesShowMoreProps, ref) => {
  const { isContentOverflowing, vehicleFeatures } = props;
  return (
    <>
      <Styled.Title>Vehicle Features</Styled.Title>

      <SeeMoreFade
        mobileContainerMaxHeight={166}
        isContentOverflowing={isContentOverflowing}
      >
        <div ref={ref}>
          {vehicleFeatures.map(
            (feature: MappedVehicleFeatures, index: number) => {
              return (
                <Styled.FeatureGroup key={index} data-testId="vehicle-group">
                  <InfoTitle
                    title={
                      <Styled.CategoryTitle>
                        {feature.category}
                      </Styled.CategoryTitle>
                    }
                    listItems={feature.features}
                  />
                </Styled.FeatureGroup>
              );
            },
          )}
        </div>
      </SeeMoreFade>
    </>
  );
});

VehicleFeaturesShowMore.displayName = 'DealerhubHeaderDropdown';

export default VehicleFeaturesShowMore;
